import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "120",
  height: "120",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#303C42",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M7.5 15v36.5c0 4 1.5 8 4.5 10.5l47 47c2.5 2.5 5.5 3.5 8.5 3.5S74 111 76 109l33-33c2.5-2.5 3.5-5.5 3.5-8.5S111 61 109 59L62 12q-4.5-4.5-10.5-4.5H15c-4 0-7.5 3.5-7.5 7.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#C301FF",
      stroke: "#303C42",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M25 32.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#303C42",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "7",
      d: "m57.502 43-7 7c-4 4-4 10 0 14s10 4 14 0 10-4 14 0 4 10 0 14l-7 7m-21-34.5-3.5-3.5m31.5 31.5 3.5 3.5"
    }, null, -1)
  ])))
}
export default { render: render }